import Vue from 'vue'

export default {
  storeArticles (state, articlesPagination) {
    state.article_pages = articlesPagination.last_page
    state.total_articles = articlesPagination.total
    articlesPagination.data.forEach((article) => {
      Vue.set(article, 'page', articlesPagination.current_page)
      this.commit('storeArticle', article)
    })
  },
  storeArticle (state, article) {
    const articleIndex = state.articles.findIndex(item => item.id === article.id)
    if (articleIndex === -1) {
      state.articles.push(article)
    } else {
      if (state.articles[articleIndex].page) {
        Vue.set(article, 'page', state.articles[articleIndex].page)
      }
      Vue.set(state.articles, articleIndex, article)
    }
  },
  storeWarnings (state, warnings) {
    Vue.set(state, 'warnings', warnings)
  },
  clearLatestEvents (state) {
    Vue.set(state, 'latestEvents', [])
  },
  storeLatestEvent (state, event) {
    state.latestEvents.push(event)
  },
  storeDropdown (state, dropdown) {
    if (!state.dropdowns.some(e => e.id === dropdown.id)) {
      Vue.set(state.dropdowns, state.dropdowns.length, dropdown)
    }
  },
  storeSite (state, site) {
    if (!state.sites.some(e => e.id === site.id)) {
      Vue.set(state.sites, state.sites.length, site)
    }
  },
  storeSection (state, section) {
    if (!state.sections.some(e => e.id === section.id)) {
      Vue.set(state.sections, state.sections.length, section)
    }
  },
  storeQuickAccess (state, quickaccess) {
    Vue.set(state, 'quickaccess', quickaccess)
  },
  storeNavEntry (state, entry) {
    Vue.set(state.navbar, state.navbar.length, entry)
  },
  storeNav (state, entrys) {
    Vue.set(state, 'navbar', entrys)
  },
  setKey (state, key) {
    Vue.set(state, 'key', key)
  },
  siteUnlocked (state, siteId) {
    const site = state.sites.find((element) => element.id === siteId)
    if (site !== undefined) Vue.set(site, 'unlocked', 1)
  }
}
